import { TCompanyRolePermissionsMe } from 'redux-store/api/company-roles';

export const getBadgesPermissions = (permissions: TCompanyRolePermissionsMe) => {
  const {
    ACTIVITY_FEED_MY_POSTS,
    ACTIVITY_FEED_ALL_POSTS,
    ENABLE_ACTIVITY_FEED,
    MANAGE_SELECTIONS,
  } = permissions || {};

  const hasActivityFeedAccess =
    ACTIVITY_FEED_MY_POSTS?.canRead &&
    ACTIVITY_FEED_ALL_POSTS?.canRead &&
    ENABLE_ACTIVITY_FEED?.canRead;

  return {
    isActivityButtonShow: hasActivityFeedAccess,
    isNotificationButtonShow: hasActivityFeedAccess || MANAGE_SELECTIONS?.canRead,
    isAlertButtonShow: true,
  };
};
